import { React, createElement } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// 홈
import Dashboard from '../pages/Dashboard'

// 주문현황
import TodayOrderList from '../pages/todayOrderList/TodayOrderList' // 당일
import SelectOrderList from '../pages/selectOrderList/SelectOrderList' // 기간별

// 메뉴,옵션관리
import ItemList from '../pages/itemList/ItemList'
import OptionList from '../pages/itemList/OptionList'

// 매장관리
import StoreList from '../pages/storeList/StoreList'
import ManageStoreInfo from '../pages/storeList/ManageStoreInfo'
import StoreDeliveryInfo from '../pages/storeList/StoreDeliveryInfo'

//FAQ
import UseFaqPage from '../pages/faq/UseFaqPage'

// 정산내역
import Settlements from '../pages/settlements/Settlements' // 정산관리

// 부가세 신고자료
import VatReport from '../pages/vatReport/VatReport'

// 통계
import Stat from '../pages/stat/Stat'

// 리뷰관리
import ReviewList from '../pages/reviewList/ReviewList'

// (해피오더) 공지사항
import NoticeList from '../pages/notice/NoticeList' // 목록
import NoticeDetail from '../pages/notice/NoticeDetail' // 상세

// (매장) 공지사항
import StoreNotice from '../pages/notice/StoreNotice'

// 이용가이드
import UseGuide from '../pages/useGuide/UseGuide'

// 로그인
import SignIn from '../pages/signIn/SignIn'
import FindId from '../pages/signIn/FindId'
import ResetPassword from '../pages/signIn/ResetPassword'
import ChangePassword from '../pages/signIn/ChangePassword'
import AgentPOS from '../pages/agentPOS/AgentPOS'

// 약관
import PrivacyTerms from '../pages/terms/PrivacyTerms'
import ServiceTerms from '../pages/terms/ServiceTerms'

// 404
import NoMatch from '../utils/NoMatch'

// 에러
import Error from '../pages/Error'

const Router = ({ hiddenYn }) => {
  const hiddenYnRoutes = [
    { path: '/todayOrderList', component: TodayOrderList },
    { path: '/selectOrderList', component: SelectOrderList },
    { path: '/storeDeliveryInfo', component: StoreDeliveryInfo },
    { path: '/totalOrder', component: Stat },
    { path: '/settlements', component: Settlements },
  ]

  // hiddenYn이 null이 아닌 경우에만 해당 라우트를 매핑
  const dynamicRoutes = hiddenYn ? hiddenYnRoutes : []

  return (
    <>
      <Routes>
        {/* 메인 라우팅 */}
        <Route path="/" element={<Dashboard />} />

        {/* 서브페이지 라우팅 (히든메뉴(Y,N)에 대한 라우팅 세팅) */}
        {dynamicRoutes &&
          hiddenYnRoutes.map(({ path, component }) => (
            <Route key={path} path={path} element={createElement(component)} />
          ))}

        {/* 서브페이지 라우팅 (기본 default) */}
        <Route path="/itemList" element={<ItemList />} />
        <Route path="/optionList" element={<OptionList />} />
        <Route path="/storeList" element={<StoreList />} />
        <Route path="/manageStoreInfo" element={<ManageStoreInfo />} />
        <Route path="/vatReport" element={<VatReport />} />
        <Route path="/reviewList" element={<ReviewList />} />
        <Route path="/happyOrderNoticeList" element={<NoticeList />} />
        <Route path="/storeNoticeList" element={<NoticeList />} />
        <Route path="/happyOrderNoticeList/:id" element={<NoticeDetail />} />
        <Route path="/useguide" element={<UseGuide />} />
        <Route path="/useFaq" element={<UseFaqPage />} />
        <Route path="/usePos" element={<UseFaqPage />} />
        <Route path="/agentPOS" element={<AgentPOS />} />
        <Route path="/privacyterms" element={<PrivacyTerms />} />
        <Route path="/serviceterms" element={<ServiceTerms />} />
        <Route path="/error" element={<Error />} />
        <Route path="/*" element={<Error />} />
      </Routes>
    </>
  )
}

export default Router
